<template>
    <div class="user-lic-mng">
        <div class="list-controls">
            <div class="tab swiper-container">
                <ul class="swiper-wrapper">
                    <li class="swiper-slide" :class="{ 'active': state.activeSubTab === 'members' }">
                        <a href="javascript:;" @click="switchSubTab('members')">팀원별</a>
                    </li>
                    <li class="swiper-slide" :class="{ 'active': state.activeSubTab === 'groups' }">
                        <a href="javascript:;" @click="switchSubTab('groups')">그룹별</a>
                    </li>
                    <li class="swiper-slide" :class="{ 'active': state.activeSubTab === 'products' }">
                        <a href="javascript:;" @click="switchSubTab('products')">제품별</a>
                    </li>
                </ul>
            </div>

            <div class="gui-form">
                <div class="row-box">
                    <div class="sel-inp-set">
                        <label>팀:</label>
                        <select v-model.number="state.selectedCrewId" @change="onChangeCrew">
                            <option v-for="c in state.crews" :key="c[CREW_KEYS.id]" :value="c[CREW_KEYS.id]">
                                {{ c[CREW_KEYS.name] }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <component :is="activeSubComponent" 
                   :selectedCrewId="state.selectedCrewId"
                   @request-refresh-crews="fetchCrews" />
    </div>
</template>

<script>
export default {
    name: 'userLicenseManagement',
    data() {
        return {
            CREW_KEYS: { id: 'id', name: 'crewName' },
            state: {
                activeSubTab: 'members',
                crews: [],
                selectedCrewId: null,
                loading: { crews: false },
            },
        };
    },
    computed: {
        activeSubComponent() {
            if (!this.state.selectedCrewId) return () => import('./tabs/membersTab.vue');
            if (this.state.activeSubTab === 'members') return () => import('./tabs/membersTab.vue');
            if (this.state.activeSubTab === 'groups') return () => import('./tabs/groupsTab.vue');
            if (this.state.activeSubTab === 'products') return () => import('./tabs/productsTab.vue');
            return () => import('./tabs/membersTab.vue');
        },
    },
    methods: {
        switchSubTab(tab) {
            if (this.state.activeSubTab === tab) return;
            
            // 현재 스크롤 위치 저장
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            
            this.state.activeSubTab = tab;
            // 쿼리 파라미터 업데이트 (선택된 crewId 유지)
            const query = {
                ...this.$route.query,
                mainTab: 'user',
                subTab: tab
            };
            // 현재 선택된 팀이 있으면 쿼리에 포함
            if (this.state.selectedCrewId) {
                query.crewId = this.state.selectedCrewId;
            }
            this.$router.replace({
                name: 'licenseManagement',
                query: query
            }).then(() => {
                // 스크롤 위치 복원
                this.$nextTick(() => {
                    window.scrollTo(0, scrollPosition);
                });
            });
            // 각 서브 컴포넌트가 selectedCrewId 변화를 watch 하며 로딩합니다.
        },
        onChangeCrew() {
            // 현재 스크롤 위치 저장
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            
            // 팀 변경 시 쿼리 파라미터에 저장하여 탭 간 이동 시 유지되도록 함
            if (this.state.selectedCrewId) {
                this.$router.replace({
                    name: 'licenseManagement',
                    query: {
                        ...this.$route.query,
                        mainTab: 'user',
                        subTab: this.state.activeSubTab,
                        crewId: this.state.selectedCrewId
                    }
                }).then(() => {
                    // 스크롤 위치 복원
                    this.$nextTick(() => {
                        window.scrollTo(0, scrollPosition);
                    });
                });
            }
            // 하위 컴포넌트가 watch 하여 데이터를 새로 불러오도록 합니다.
        },
        fetchCrews() {
            if (!this.isLogin()) {
                return;
            }
            this.state.loading.crews = true;
            // 현재 선택된 팀 ID를 임시 저장 (유지하기 위해)
            const currentSelectedCrewId = this.state.selectedCrewId;
            
            return new Promise((resolve) => {
                this.axiosCaller.get(
                    this,
                    this.APIs.LICENSE + '/getUserCrewList',
                    {},
                    (result) => {
                        try {
                            const list = this.getSafeArray(result);
                            this.state.crews = list;
                            
                            // 쿼리 파라미터에서 crewId 읽기
                            const queryCrewId = this.$route.query?.crewId;
                            
                            if (queryCrewId && list.length > 0) {
                                // 쿼리 파라미터에 crewId가 있으면 그것을 우선 사용
                                const crew = list.find(c => c[this.CREW_KEYS.id] == queryCrewId);
                                if (crew) {
                                    this.state.selectedCrewId = crew[this.CREW_KEYS.id];
                                } else if (currentSelectedCrewId) {
                                    // 쿼리 파라미터의 crewId가 리스트에 없지만 현재 선택된 팀이 있으면 유지
                                    const currentCrew = list.find(c => c[this.CREW_KEYS.id] == currentSelectedCrewId);
                                    if (currentCrew) {
                                        this.state.selectedCrewId = currentSelectedCrewId;
                                    } else if (list.length > 0) {
                                        // 현재 선택된 팀도 리스트에 없으면 첫 번째로
                                        this.state.selectedCrewId = list[0][this.CREW_KEYS.id];
                                    }
                                } else if (list.length > 0) {
                                    this.state.selectedCrewId = list[0][this.CREW_KEYS.id];
                                }
                            } else if (currentSelectedCrewId) {
                                // 쿼리 파라미터에 crewId가 없지만 현재 선택된 팀이 있으면 유지
                                const currentCrew = list.find(c => c[this.CREW_KEYS.id] == currentSelectedCrewId);
                                if (currentCrew) {
                                    this.state.selectedCrewId = currentSelectedCrewId;
                                } else if (list.length > 0) {
                                    // 현재 선택된 팀이 리스트에 없으면 첫 번째로
                                    this.state.selectedCrewId = list[0][this.CREW_KEYS.id];
                                }
                            } else if (list.length > 0) {
                                // 아무것도 없으면 첫 번째로
                                this.state.selectedCrewId = list[0][this.CREW_KEYS.id];
                            }
                        } finally {
                            this.state.loading.crews = false;
                            resolve();
                        }
                    }
                );
            });
        },
        // 공통 유틸 (원본에서 사용하던 형태 유지)
        getData(resOrData) { return resOrData?.data ?? resOrData; },
        getSafeArray(resOrData) {
            const result = this.getData(resOrData);
            if (result?.status && result.status !== 'ok') {
                this.gritterErr(result?.msg || '요청이 실패했습니다.');
                return [];
            }
            const topCandidates = [result?.list, result?.rows, result?.content, result?.data];
            for (const v of topCandidates) if (Array.isArray(v)) return v;
            const nestedCandidates = [result?.data?.list, result?.data?.rows, result?.data?.content];
            for (const v of nestedCandidates) if (Array.isArray(v)) return v;
            if (result && typeof result === 'object') {
                for (const k of Object.keys(result)) if (Array.isArray(result[k])) return result[k];
            }
            return [];
        },
        gritterErr(msg) { const m = msg || '정상적인 접근이 아닙니다. 다시 시도해주세요.'; this.swalUtils?.gritter ? this.swalUtils.gritter('error', m, 'error', 2000) : console.error('[ERR]', m); },
    },
    watch: {
        '$route.query.subTab'(newSubTab) {
            if (newSubTab && ['members', 'groups', 'products'].includes(newSubTab)) {
                this.state.activeSubTab = newSubTab;
            }
        },
    },
    mounted() {
        // 로그인 체크
        if (!this.isLogin()) {
            return;
        }
        
        // 쿼리 파라미터에서 하위 탭 정보 읽기
        const querySubTab = this.$route.query?.subTab;
        if (querySubTab && ['members', 'groups', 'products'].includes(querySubTab)) {
            this.state.activeSubTab = querySubTab;
        } else {
            // subTab이 없으면 기본값으로 설정
            this.state.activeSubTab = 'members';
        }
        this.fetchCrews();
    },
};
</script>

<style scoped>
</style>


